import React from 'react';

import { PopoverPosition } from '@blueprintjs/core';

import { Field, InputGroup } from 'core/form';
import { Box, Button, ColorBlock, ColorPicker, Flex, Popover, Tag } from 'core/components';

const ColorButton = ({ color }) => (
  <Button style={{ padding: '0 6px', marginRight: 8 }}>
    <ColorBlock
      color={color}
      style={{
        boxShadow: 'none',
        width: 16,
        height: 16,
        border: '1px solid rgba(16, 22, 26, 0.2)'
      }}
    />
  </Button>
);

const ColorPickerField = ({ field, label }) => (
  <Field className="no-margin" field={field} fieldStyle={{ minWidth: 137 }} showLabel={false} validateOptions={false}>
    {({ value, onChange }) => {
      const change = (val) => {
        onChange(val);
      };

      return (
        <Flex align="center" mr={2}>
          <Popover
            minimal={false}
            placement={PopoverPosition.AUTO_START}
            modifiers={{
              flip: { enabled: false },
              preventOverflow: { enabled: true, boundariesElement: 'window' }
            }}
          >
            <ColorButton color={value} />
            <ColorPicker color={value} onChange={(newVal) => change(newVal.hex)} triangle="hide" />
          </Popover>
          <Box flex="1 auto">
            <InputGroup
              field={field}
              onChange={change}
              placeholder="# Enter hex..."
              rightElement={<Tag minimal>{label}</Tag>}
              value={value}
            />
          </Box>
        </Flex>
      );
    }}
  </Field>
);

export default ColorPickerField;
